<template>
  <tr
    :key="'orig-' + (item.originalId || index)"
    class="row-original-product grey lighten-5"
  >
    <td
      class="text-center font-weight-bold grey--text text--darken-2 white"
      rowspan="2"
    >
      {{ index + 1 }}
    </td>
    <td>
      <div
        class="py-2 d-flex align-center"
        style="min-width: 320px"
      >
        <v-icon
          x-small
          color="grey darken-2"
          class="mr-1 flex-shrink-0"
          >mdi-food</v-icon
        >
        <span
          class="font-weight-bold grey--text text--darken-3"
          style="word-break: break-word"
        >
          {{ item.originalNombre }}
        </span>
      </div>
    </td>
    <td>
      <div
        class="py-1 font-family-monospace grey--text text--darken-2 font-weight-medium"
        style="min-width: 155px"
      >
        {{ item.originalCodigo || "-" }}
      </div>
    </td>
    <td>
      <div
        class="py-1 grey--text text--darken-2 text-truncate"
        style="min-width: 235px"
      >
        {{
          getCategoryNameById(
            item.rawOriginal && item.rawOriginal.Categoria
          )
        }}
      </div>
    </td>
    <td>
      <div
        class="py-1 grey--text text--darken-3 font-weight-medium"
        style="min-width: 195px"
      >
        ${{
          $pgsHelper.formatNumber(item.originalPrecio || 0)
        }}
        {{
          (item.rawOriginal && item.rawOriginal.Moneda) ||
          item.Moneda ||
          ""
        }}
      </div>
    </td>
    <!-- 7. Original Vigencia -->
    <td>
      <div
        v-if="currentStep === 0"
        class="py-1"
        style="min-width: 175px"
      >
        <v-text-field
          :value="formattedOriginalVaun"
          readonly
          dense
          outlined
          hide-details
          placeholder="Sin vigencia"
          prepend-inner-icon="mdi-calendar"
          background-color="#f8fafc"
          class="font-weight-medium grey--text text--darken-3"
          style="font-size: 13px"
        ></v-text-field>
      </div>
      <div
        v-else
        class="py-1 grey--text text--darken-3 text-caption d-flex align-center"
        style="min-width: 175px"
      >
        <v-icon x-small color="grey darken-1" class="mr-1"
          >mdi-calendar-clock</v-icon
        >
        {{ formattedOriginalVaun || "Sin vigencia" }}
      </div>
    </td>

    <!-- 8. Original Deptos y Almacenes -->
    <td>
      <div
        class="py-1"
        style="min-width: 280px; max-width: 360px"
      >
        <template v-if="originalDeptosRows.length === 0">
          <span
            class="caption red--text text--darken-2 font-weight-bold d-flex align-center"
          >
            <v-icon x-small color="red" class="mr-1">mdi-alert-circle</v-icon>
            Sin departamentos
          </span>
        </template>
        <template v-else>
          <div class="d-flex align-center justify-space-between mb-1">
            <span class="text-caption font-weight-bold grey--text text--darken-2">
              {{ originalDeptosRows.length }} depto(s) vinculado(s)
            </span>
          </div>
          <v-card
            outlined
            class="pa-1.5 px-2 rounded-lg"
            style="background-color: #f8fafc; border-color: #cbd5e1;"
          >
            <div
              v-for="d in originalDeptosRows"
              :key="'orig-d-' + d.depto"
              class="mb-1"
            >
              <span
                class="font-weight-bold text-caption d-flex align-center grey--text text--darken-3"
              >
                <v-icon small color="grey darken-2" class="mr-1">mdi-domain</v-icon>
                {{ d.deptoName }}
              </span>
              <div
                v-if="!d.origenes || d.origenes.length === 0"
                class="mt-0.5"
              >
                <span
                  class="caption orange--text font-weight-medium"
                  style="font-size: 10px"
                >
                  <v-icon x-small color="orange" class="mr-1">mdi-warehouse</v-icon>
                  Sin almacén
                </span>
              </div>
              <div
                v-else
                class="d-flex align-center flex-wrap mt-0.5"
                style="gap: 4px"
              >
                <v-chip
                  v-for="orig in d.origenes"
                  :key="'orig-orn-' + orig"
                  x-small
                  color="grey lighten-4"
                  class="grey--text text--darken-3 font-weight-medium"
                >
                  <v-icon left x-small color="grey darken-1">mdi-warehouse</v-icon>
                  {{ getOrigenName(orig) }}
                </v-chip>
              </div>
            </div>
          </v-card>
        </template>
      </div>
    </td>
    <!-- 9. Original Insumos -->
    <td>
      <div
        class="py-1"
        style="min-width: 260px; max-width: 320px"
      >
        <div
          class="d-flex align-center justify-space-between mb-1"
        >
          <span
            class="text-caption font-weight-bold grey--text text--darken-2"
          >
            {{ getOriginalInsumos(item).length }} insumo(s)
          </span>
        </div>
        <template
          v-if="getOriginalInsumos(item).length === 0"
        >
          <div
            class="d-flex align-center grey--text text-caption py-1"
          >
            <v-icon
              x-small
              color="grey lighten-1"
              class="mr-1"
              >mdi-information-outline</v-icon
            >
            <span style="font-size: 11px">Sin insumos</span>
          </div>
        </template>
        <template v-else>
          <div
            class="d-flex flex-column pr-1"
            style="
              max-height: 96px;
              overflow-y: auto;
              gap: 2px;
            "
          >
            <div
              v-for="(ins, origInsIdx) in getOriginalInsumos(item)"
              :key="'orig-ins-' + origInsIdx"
              class="text-caption d-flex align-center justify-space-between px-2 py-0.5 rounded"
              style="
                background-color: #f1f5f9;
                font-size: 11px;
                line-height: 1.25;
              "
            >
              <span
                class="text-truncate font-weight-medium text--primary mr-1"
                style="max-width: 170px"
              >
                • {{ getInsumoDisplayName(ins) }}
              </span>
              <span
                class="font-weight-bold flex-shrink-0 grey--text text--darken-3"
                style="font-size: 10.5px"
              >
                {{
                  ins.Cantidad !== undefined ? ins.Cantidad : 1
                }}
                {{ getInsumoUM(ins) }}
              </span>
            </div>
          </div>
        </template>
      </div>
    </td>

    <!-- 10. Original Modificadores -->
    <td>
      <div
        class="py-1"
        style="min-width: 250px; max-width: 310px"
      >
        <div
          class="d-flex align-center justify-space-between mb-1"
        >
          <span
            class="text-caption font-weight-bold purple--text text--darken-3"
          >
            {{ getOriginalModificadores(item).length }} grupo(s)
          </span>
        </div>
        <template
          v-if="getOriginalModificadores(item).length === 0"
        >
          <div
            class="d-flex align-center grey--text text-caption py-1"
          >
            <v-icon
              x-small
              color="grey lighten-1"
              class="mr-1"
              >mdi-information-outline</v-icon
            >
            <span style="font-size: 11px">Sin modificadores</span>
          </div>
        </template>
        <template v-else>
          <div
            class="d-flex flex-column pr-1"
            style="
              max-height: 96px;
              overflow-y: auto;
              gap: 2px;
            "
          >
            <div
              v-for="(mod, origModIdx) in getOriginalModificadores(item)"
              :key="'orig-mod-' + origModIdx"
              class="text-caption d-flex align-center justify-space-between px-2 py-0.5 rounded"
              style="
                background-color: #f3e8ff;
                font-size: 11px;
                line-height: 1.25;
              "
            >
              <span
                class="text-truncate font-weight-medium purple--text text--darken-4 mr-1"
              >
                • {{ getModificadorName(mod.id || mod.Id) }}
              </span>
              <span
                v-if="mod.orn"
                :class="['text-caption font-weight-bold flex-shrink-0', themeTextClass]"
                style="font-size: 10px"
              >
                [{{ getModificadorOrigenName(mod.orn) }}]
              </span>
            </div>
          </div>
        </template>
      </div>
    </td>
    <td>
      <div
        class="py-1 d-flex align-center justify-center"
        style="min-width: 215px"
      >
        <v-icon
          v-for="ch in channelConfigs"
          :key="ch.key"
          size="19"
          :color="
            !(item.rawOriginal && item.rawOriginal[ch.key])
              ? (ch.refColor || ch.activeColor)
              : '#cbd5e1'
          "
          class="mx-1"
        >
          {{
            (item.rawOriginal && item.rawOriginal[ch.key])
              ? (ch.refIconOff || ch.iconOff || ch.icon)
              : (ch.refIcon || ch.icon)
          }}
        </v-icon>
      </div>
    </td>
    <td>
      <div
        class="py-1 grey--text text--darken-2 text-caption text-truncate"
        style="min-width: 265px; max-width: 280px"
      >
        {{
          item.rawOriginal &&
          item.rawOriginal.tags &&
          item.rawOriginal.tags.length > 0
            ? item.rawOriginal.tags.join(", ")
            : "Sin etiquetas"
        }}
      </div>
    </td>
    <td>
      <div
        class="py-1 grey--text text--darken-2 text-caption text-truncate"
        style="min-width: 285px; max-width: 320px"
      >
        {{
          (item.rawOriginal && item.rawOriginal.dscr) ||
          "Sin descripción"
        }}
      </div>
    </td>
    <td
      v-if="currentStep === 0"
      class="text-center white"
      rowspan="2"
    >
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            small
            v-bind="attrs"
            v-on="on"
            color="red darken-1"
            @click="$emit('remove', item)"
          >
            <v-icon>mdi-delete-outline</v-icon>
          </v-btn>
        </template>
        <span>Quitar de la lista</span>
      </v-tooltip>
    </td>
  </tr>
</template>

<script>
import ReplicadorRecetas, {
  getInsumoDisplayName,
  getInsumoUM,
  getModificadorName,
  getOrigenName,
  getOriginalInsumos,
  getOriginalModificadores,
  getOriginalDeptosSummary,
  getOriginalDeptosRows,
  formatVaunDate,
} from "../../../../clases/Restaurante/ReplicadorRecetas.js";

export default {
  name: "FilaRecetaOriginal",
  props: {
    item: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    currentStep: {
      type: Number,
      default: 0,
    },
    channelConfigs: {
      type: Array,
      default: () => [],
    },
    categoriesMap: {
      type: Map,
      default: () => new Map(),
    },
    modulosMap: {
      type: Map,
      default: () => new Map(),
    },
    origenesMap: {
      type: Map,
      default: () => new Map(),
    },
    modificadoresMap: {
      type: Map,
      default: () => new Map(),
    },
    productsMap: {
      type: Map,
      default: () => new Map(),
    },
    modulos: {
      type: Array,
      default: () => [],
    },
    origenes: {
      type: Array,
      default: () => [],
    },
    themeTextClass: {
      type: String,
      default: "primary--text",
    },
  },
  computed: {
    originalDeptosRows() {
      return getOriginalDeptosRows(
        this.item,
        this.modulosMap,
        this.modulos
      );
    },
    formattedOriginalVaun() {
      const raw =
        (this.item.rawOriginal && this.item.rawOriginal.Vaun) ||
        this.item.originalVaun ||
        this.item.vaunAux ||
        this.item.Vaun;
      return formatVaunDate(raw);
    },
  },
  methods: {
    getCategoryNameById(catId) {
      if (!catId) return "Sin categoría";
      return this.categoriesMap.get(catId) || catId;
    },
    getOriginalDeptosRows(item) {
      return getOriginalDeptosRows(item, this.modulosMap, this.modulos);
    },
    getOrigenName(origenId) {
      return getOrigenName(origenId, this.origenesMap, this.origenes);
    },
    getOriginalDeptosSummary(item) {
      return getOriginalDeptosSummary(
        item,
        this.modulosMap,
        this.modulos,
        this.origenesMap,
        this.origenes
      );
    },
    getOriginalInsumos(item) {
      return getOriginalInsumos(item);
    },
    getOriginalModificadores(item) {
      return getOriginalModificadores(item);
    },
    getInsumoDisplayName(ins) {
      return getInsumoDisplayName(ins, this.productsMap);
    },
    getInsumoUM(ins) {
      return getInsumoUM(ins, this.productsMap);
    },
    getModificadorName(id) {
      return getModificadorName(id, this.modificadoresMap);
    },
    getModificadorOrigenName(orn) {
      return getOrigenName(orn, this.origenesMap, this.origenes);
    },
  },
};
</script>
